import React, { useEffect, useState } from "react";
import { Button, Container } from "react-bootstrap";
import Filters from "../../components/Filters/index";
import Edit from "../../components/Modal/Sells/suspended/edit";
import List from "../../components/Table/List";
import ExcelButton from "../../components/ExcelButton";
import { useGrid, useStatusModal } from "../../hooks/index";
import authService from "../../services/auth.service";
import SellsSuspendedService from "../../services/sells/sellsSuspended.service";
import {
  badgeGeneric,
  badgeGenericBoolean,
  diffDateBadge,
  genericBadge,
  twoBadges,
} from "../../utils/Badges";
import { sellEmployees } from "../../utils/Service";
import Modal from "../../layouts/ModalDisplay";
import { sells_status, sells_status_select } from "../../variables/constants";
import { FINANCED_STATUS_NAME } from "../../variables/sells/index";
import styles from "../Purchase/General/styles.module.scss";
import { headSuspended } from "./constants/constants_columns";

const filterFields = {
  plate_number: {
    type: "text",
    name: "plate_number",
    placeholder: "Dominio",
    value: "",
    size: 2,
  },
  person_in_charge: {
    type: "select",
    name: "person_in_charge",
    options: sellEmployees(),
    placeholder: "Persona Responsable",
    value: "",
    size: 2,
  },
  status: {
    type: "multiSelect",
    name: "status",
    options: sells_status_select.filter((x) => x.suspended === true),
    placeholder: "Estado",
    value: [],
    size: 8,
  },
};

const sortColumns = (body) => {
  return body.map((e) => ({
    opportunity_id: e.opportunity_id,
    plate_number: twoBadges(
      e.plate_number,
      e.financed ? FINANCED_STATUS_NAME.FINANCED : null
    ),
    stock_id: e.stock_id,
    status: genericBadge(sells_status, e.status),
    year: e.year,
    month: e.month,
    week: e.week,
    delivery_date: e.delivery_date,
    estimated_delivery_date: e.estimated_delivery_date,
    estimated_end_trial: e.estimated_end_trial,
    suspended_date: e.suspended_date,
    person_in_charge_id: e.person_in_charge_id,
    suspended_period: badgeGeneric("info", e.suspended_period),
    aging: diffDateBadge(e.aging),
    diff_days: diffDateBadge(e.diff_days),
    past_suspended_date: e.past_suspended_date,
    bacs_id: badgeGenericBoolean(e.bacs_id),
  }));
};

const sort = {
  model: null,
  field: "opportunity_id",
  type: "ASC",
};

const SuspendedList = (props) => {
  const { handleCloseEditModal, handleOpenEditModal, showEditModal } =
    useStatusModal();

  const {
    body,
    countItems,
    currentPage,
    currentSort,
    totalItems,
    totalPage,
    handleBody,
    handleSort,
    handleToPage,
    handleTotalItems,
    handleTotalPage,
    cleanPage,
  } = useGrid(sort);

  const [refresh, setRefresh] = useState(new Date());
  const [dataModal, setDataModal] = useState([]);
  const [filters, setFilters] = useState(filterFields);
  const [currentPermissions, setCurrentPermissions] = useState(null);

  const next = {
    link: "/admin/management/toma-vehiculo",
    text: "Toma",
  };

  useEffect(() => {
    const permissions = authService.getCurrentPermissions("SUSPENDIDOS VENTAS");
    setCurrentPermissions(permissions);
  }, []);

  const onFilterChange = (filterName, filterValue) => {
    setFilters({
      ...filters,
      [filterName]: { ...filters[filterName], value: filterValue },
    });
    cleanPage();
  };

  const refreshGrid = () => {
    setRefresh(new Date());
  };

  const openEditModal = (id) => {
    SellsSuspendedService.getById(id).then((response) => {
      if (response.data.success) {
        setDataModal(response.data);
        handleOpenEditModal();
      }
    });
  };

  useEffect(() => {
    const params = {
      page: currentPage,
      limit: countItems, // like countItems
      sortModel: currentSort?.model,
      sortField: currentSort?.field,
      sortType: currentSort?.type,
      filters,
    };

    SellsSuspendedService.getAll(params).then((response) => {
      handleTotalItems(response.data.totalItems);
      handleTotalPage(Math.ceil(response.data.totalItems / countItems));
      handleBody(sortColumns(response.data.response));
    });
    //eslint-disable-next-line
  }, [currentPage, currentSort, countItems, filters, refresh]);

  const actions = (props) => {
    return (
      <>
        {currentPermissions && currentPermissions.permissions.hasSelect && (
          <Button
            onClick={(e) => openEditModal(props.opportunity_id, e)}
            className="btn-simple btn btn-xs btn-secondary"
          >
            <i className="fas fa-file-alt" aria-hidden="true"></i>
          </Button>
        )}
      </>
    );
  };

  return (
    <div className="content">
      <div className={styles.export}>
        <ExcelButton type="ventasSuspendidos" filters={filters} />
      </div>
      <Filters filterFields={filters} onFilterChange={onFilterChange} />
      <List
        thead={headSuspended}
        tbody={body}
        actions={actions}
        next={next}
        totalItems={totalItems}
        currentPage={currentPage}
        totalPage={totalPage}
        toPage={handleToPage}
        handleSort={handleSort}
        sortable
        currentSort={currentSort}
      />
      {showEditModal && (
        <Modal
          content={
            <Edit
              data={dataModal}
              handleClose={handleCloseEditModal}
              refresh={refreshGrid}
            />
          }
          showModal={showEditModal}
          handleShow={openEditModal}
          handleClose={handleCloseEditModal}
        />
      )}
    </div>
  );
};

export default SuspendedList;
